// extracted by mini-css-extract-plugin
export default {"container":"hotelsRelinking-module__container__12WkY","subheading":"hotelsRelinking-module__subheading__nhTLZ"};